var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 18.125V28.75H13.75V18.125L11.8875 10.9375H3.1125L1.25 18.125ZM9.375 1.25L11.4 9.0625H3.6L5.625 1.25H9.375ZM26.25 5L20 9.375V12.5H26.25V5ZM17.5 23.125V28.75H28.75V23.125L26.25 18.75V14.375H20V18.75L17.5 23.125Z",
    fill: "#B9004A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f1647679c64a49a06d38d9e71fe2ef5b.svg";
export { ForwardRef as ReactComponent };